import { resolve } from '../utils/objectUtils';

const defaultNamespace = 'wp/v2/';
const namespace = resolve(
  window,
  'ThemeSettings.rest.namespace',
  defaultNamespace
);
const baseRestUrl = `${window.location.href}wp-json/`;
const restUrl = resolve(window, 'ThemeSettings.rest.url', baseRestUrl);
const companiesEndpoint = resolve(
  window,
  'ThemeSettings.rest.endpoints.get_user_companies',
  'datasource'
);

export const companiesUrl = restUrl + namespace + companiesEndpoint;
export const wpNonce = resolve(window, 'ThemeSettings.rest.nonce', null);
export const companiesNotFoundMsg = resolve(
  window,
  'ThemeSettings.not_found_message',
  'На жаль, наразі немає компаній доступних вам для перегляду'
);

export const INITIAL_SERVICE_STATUS = 'idx';
export const LOADING_SERVICE_STATUS = 'loading';
export const LOADED_SERVICE_STATUS = 'loaded';
